<template>
  <div class="vaccine-details">
    <div class="d-flex modal-title-head">        
      <div class="title-head">
        <p style="text-align:center">{{ $t("common.add") }} {{$t("common.document") }}</p>
      </div>
      <svg class="closeAddDocumentModal"  @click="$bvModal.hide('addDocumentModal')" width="22"
        height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> 
          <path d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z" 
          fill="#F46A6A"/>
      </svg>
    </div>

    <div class="vaccine-and-pcr-details">

      <span class="add-document-label" v-if="form.document">
        {{ $t("common.doc.documentType") }}
      </span>
      <multiselect @input="changeDocumentType($event)" class="select-type  document-type" v-model="form.document" :options="getDocuments" 
      :placeholder="$t('common.doc.documentType')" label="name" track-by="id" />

      <div v-if="vaccineAndPrcSection">

        <div v-if="acceptNegativePcr" class="d-flex custom-radio">
          <b-form-radio-group v-model="form.vaccine_pcr" name="vaccine_pcr" class="vaccine-radio">    
            <b-form-radio @change="changeVaccineOrPcr($event)" value="covid_vaccine">{{ $t('common.doc.vaccine') }}</b-form-radio> 
          </b-form-radio-group>

          <b-form-radio-group v-model="form.vaccine_pcr" name="vaccine_pcr" class="pcr-radio">   
            <b-form-radio @change="changeVaccineOrPcr($event)" value="covid_pcr">{{ $t('common.doc.pcr') }}</b-form-radio> 
          </b-form-radio-group>
        </div>


        <div v-if="form.vaccine_pcr == 'covid_vaccine'" class="vaccine-inputs-wrapper">
          <!-- Protocol -->
          <span class="add-document-label" v-if="vaccine.vaccine_protocol">
              {{$t('common.doc.vaccineProtocol')}}
          </span>
          <multiselect id="protocols" class="protocols-multiselect" v-model="vaccine.vaccine_protocol"
            :options="protocolsOptions" :placeholder="$t('common.doc.vaccineProtocol')"/>

          <!-- name   -->
          <div class="form-group m-d-gruop">
            <b-form-input id="vaccineName" v-model="vaccine.vaccine_name" type="text" maxlength="30" required/>
            <label for="vaccineName">{{ $t('common.doc.vaccineName') }}</label>
          </div>

          <!-- number   -->

          <div class="form-group m-d-gruop">
            <b-form-input id="vaccineNumber" v-model="vaccine.vaccine_number" type="text" class="vaccine-name"  required/>
              <label for="vaccineNumber">{{ $t('common.doc.batchNumber')}} {{$t('common.optionalWithBrackets')}}</label>
          </div>

          <div class="dates-con d-flex">
            <!-- given date  -->
            <b-form-group>
              <span class="add-document-date-label" v-if="vaccine.vaccine_taken_date">
                {{$t('common.doc.dateTaken')}}
              </span>
              <date-picker id="date" v-model="vaccine.vaccine_taken_date" :first-day-of-week="1" @input="changeVaccineDateTaken"
                :placeholder="$t('common.doc.dateTaken')" type="date" value-type="format" format="DD/MM/YYYY" :disabledDate="disableDateAfterCurrent">
                <i slot="icon-calendar">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :fill=" vaccine.vaccine_taken_date ? '#103F5E' : '#787878'"
                      d="M0.666626 14.8327C0.666626 16.2493 1.74996 17.3327 3.16663 17.3327H14.8333C16.25 17.3327 17.3333 16.2493 17.3333 14.8327V8.16602H0.666626V14.8327ZM14.8333 2.33268H13.1666V1.49935C13.1666 0.999349 12.8333 0.666016 12.3333 0.666016C11.8333 0.666016 11.5 0.999349 11.5 1.49935V2.33268H6.49996V1.49935C6.49996 0.999349 6.16663 0.666016 5.66663 0.666016C5.16663 0.666016 4.83329 0.999349 4.83329 1.49935V2.33268H3.16663C1.74996 2.33268 0.666626 3.41602 0.666626 4.83268V6.49935H17.3333V4.83268C17.3333 3.41602 16.25 2.33268 14.8333 2.33268Z"
                    />
                  </svg>
                </i>

              </date-picker>
            </b-form-group>

            <!-- expire date  -->
            <!--  type="datetime" -->
            <b-form-group>
              <span class="add-document-date-label" v-if="vaccine.vaccine_expire_date">
                {{$t('common.doc.expiryDate')}}
              </span>
              <date-picker id="expire_date" v-model="vaccine.vaccine_expire_date" :first-day-of-week="1"
                :placeholder="$t('common.doc.expiryDate')" type="date" value-type="format" format="DD/MM/YYYY" :disabled="!vaccine.vaccine_taken_date" 
                :disabledDate="disabledExpiredDate">
                <i slot="icon-calendar" >
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :fill=" vaccine.vaccine_expire_date ? '#103F5E' : '#787878' "
                      d="M0.666626 14.8327C0.666626 16.2493 1.74996 17.3327 3.16663 17.3327H14.8333C16.25 17.3327 17.3333 16.2493 17.3333 14.8327V8.16602H0.666626V14.8327ZM14.8333 2.33268H13.1666V1.49935C13.1666 0.999349 12.8333 0.666016 12.3333 0.666016C11.8333 0.666016 11.5 0.999349 11.5 1.49935V2.33268H6.49996V1.49935C6.49996 0.999349 6.16663 0.666016 5.66663 0.666016C5.16663 0.666016 4.83329 0.999349 4.83329 1.49935V2.33268H3.16663C1.74996 2.33268 0.666626 3.41602 0.666626 4.83268V6.49935H17.3333V4.83268C17.3333 3.41602 16.25 2.33268 14.8333 2.33268Z"
                    />
                  </svg>
                </i>

              </date-picker>
            </b-form-group>
          </div>

          <!-- Vaccine File (upload) -->
          <div class="mb-3">
            <div>
              <button type="button" @click="pickImage" class="upload-btn"
                :class="{'file-validation':vaccineFileErr  && !vaccineFileUrl}"
              >
                <b-form-file accept="image/*" id="imagePicker" ref="vaccineFileRef" @change="onFileChange"
                  class="d-none upload-btn"/>
                <div class="d-flex justify-content-between w-25">
                  <p class="mt-3 file-label" :class="{'file-label-img-selected':vaccineFileUrl}">{{ $t('common.doc.vaccineFile') }}</p>
                  <span v-if="!vaccineFileUrl" class="mt-2 paperclip-icon"><i class="mdi mdi-paperclip mdi-24px"></i></span>
                </div>
              </button>
              <div v-if="vaccineFileUrl" style="position:relative">
                <img class="img-bg" :src="vaccineFileUrl"/>
                <i @click="removeImage()" class="mdi-24px remove-file-icon"
                                style="display:flex;align-items: center;justify-content: center;"
                              >
                              <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3636 2.34047C13.715 2.34047 14 2.64876 14 3.02888C14 3.40919 13.715 3.71728 13.3636 3.71728H13.3548C13.2844 3.71728 13.2253 3.7776 13.2227 3.85558L12.7646 17.2377C12.731 18.2146 11.9762 19 11.0728 19H2.92723C2.02345 19 1.26904 18.2133 1.23544 17.2377L0.777349 3.85558C0.774686 3.77932 0.717158 3.71728 0.645248 3.71728H0.63637C0.28498 3.71728 0 3.40919 0 3.02888C0 2.64876 0.28498 2.34047 0.63637 2.34047H3.73886C3.80881 2.34047 3.88143 2.28035 3.90026 2.20909L4.10764 1.42347C4.32054 0.617499 5.07747 0 5.85253 0H8.14764C8.92269 0 9.67943 0.617352 9.89252 1.42347L10.0999 2.20909C10.1191 2.2817 10.1906 2.34047 10.2613 2.34047H13.3636ZM6.49084 6.19564V15.558C6.49084 15.8622 6.71864 16.1086 6.99989 16.1086C7.28113 16.1086 7.50894 15.8622 7.50894 15.558V6.19564C7.50894 5.89139 7.28113 5.64497 6.99989 5.64497C6.71864 5.64497 6.49084 5.8914 6.49084 6.19564ZM3.6909 6.21178L3.94552 15.5741C3.95387 15.8781 4.18824 16.1175 4.4693 16.1084C4.75037 16.0996 4.97162 15.8459 4.96326 15.5418L4.70864 6.17952C4.70047 5.87546 4.46592 5.63612 4.18486 5.64517C3.90378 5.654 3.68272 5.90774 3.6909 6.21178ZM9.29096 6.17951L9.03633 15.5418C9.02799 15.8459 9.24923 16.0996 9.53029 16.1084C9.81137 16.1174 10.0458 15.8781 10.0541 15.5741L10.3087 6.21176C10.3169 5.9077 10.0958 5.65396 9.81473 5.64516C9.53366 5.63613 9.29909 5.87546 9.29096 6.17951ZM5.31773 2.34047H8.68177C8.75385 2.34047 8.79523 2.28208 8.77623 2.21005L8.66845 1.80169C8.61163 1.58676 8.35417 1.37682 8.14731 1.37682H5.85219C5.64534 1.37682 5.38787 1.58695 5.33105 1.80169L5.22328 2.21005C5.2041 2.28285 5.24653 2.34047 5.31773 2.34047Z" fill="white"/>
</svg></i>
              </div>
              
              <div class="d-flex file-note-text mt-1" v-if="!vaccineFileErr && !vaccineFileUrl || !vaccineFileUrl">
                <p class="mr-2" :class="vaccineFileErr ? 'file-err-text' : ''" >
                <b v-if="!vaccineFileErr && !vaccineFileUrl ">{{ $t("common.notes.note")}}: </b>
                  {{ $t("common.notes.uploadImgNoteDoc") }}
                </p>
              </div>

            </div>
          </div>

          <div class="notes-section" style="padding-inline-start: 0">
            <span class="add-document-label" :class='{"remove-padding":vaccine.vaccine_notes && showVaccineNoteLabel}' v-if="vaccine.vaccine_notes && !showVaccineNoteLabel">{{ $t('common.doc.documentNotes') + ' ' + $t('common.optionalWithBrackets') }}</span>
          <b-form-textarea class="add-document-notes" v-model="vaccine.vaccine_notes" rows="5" :placeholder="$t('common.doc.documentNotes') + ' ' + $t('common.optionalWithBrackets')" maxlength="255"/>
          </div>

        </div>

        <div v-if="form.vaccine_pcr == 'covid_pcr'" class="pcr-inputs-wrapperr">
          <!-- result  -->
          <b-form-group>
            <span class="add-document-label" v-if="pcr.pcr_result">PCR Result</span>
            <multiselect id="result" v-model="pcr.pcr_result" :options="pcrResultOptions"
              placeholder="PCR Result"  :show-labels="false" label="name" track-by="id"
            />
          </b-form-group>

          <!-- pcr date  -->
          <div class="d-flex justify-content-between">
            <b-form-group>
              <span class="add-document-date-label" v-if="pcr.pcr_date">
                Date Taken
              </span>
              <date-picker :first-day-of-week="1" placeholder="Date Taken" type="date"
                value-type="format" format="DD/MM/YYYY" :disabledDate="disableDateAfterCurrent"
                id="pcr_date" v-model="pcr.pcr_date" class="pcr-datepicker" >
                <i slot="icon-calendar">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :fill=" pcr.pcr_date ?'#103F5E': '#787878'"
                      d="M0.666626 14.8327C0.666626 16.2493 1.74996 17.3327 3.16663 17.3327H14.8333C16.25 17.3327 17.3333 16.2493 17.3333 14.8327V8.16602H0.666626V14.8327ZM14.8333 2.33268H13.1666V1.49935C13.1666 0.999349 12.8333 0.666016 12.3333 0.666016C11.8333 0.666016 11.5 0.999349 11.5 1.49935V2.33268H6.49996V1.49935C6.49996 0.999349 6.16663 0.666016 5.66663 0.666016C5.16663 0.666016 4.83329 0.999349 4.83329 1.49935V2.33268H3.16663C1.74996 2.33268 0.666626 3.41602 0.666626 4.83268V6.49935H17.3333V4.83268C17.3333 3.41602 16.25 2.33268 14.8333 2.33268Z"
                    />
                  </svg> 
                </i>
              </date-picker>
            </b-form-group>

            <!-- PCR File (upload) -->
            <div class="mb-3">
              <div>
                <button type="button" @click="pickImage" class="upload-btn" :class="{'file-validation':pcrFileErr  && !pcrFileUrl}">
                  <b-form-file accept="image/*" ref="pcrFileRef" id="imagePicker" @change="onFileChange" class="d-none upload-btn"/>
                  <div class="d-flex justify-content-between w-25">
                    <p class="mt-3 file-label" :class="{'file-label-img-selected': pcrFileUrl}">PCR File</p>
                    <span class="mt-2 paperclip-icon" v-if="!pcrFileUrl"><i class="mdi mdi-paperclip mdi-24px"></i></span>
                  </div>
                </button>
                <div v-if="pcrFileUrl" style="position:relative">
                  <img class="img-bg" :src="pcrFileUrl"/>
                  <i @click="removePcrImage()" class="mdi-24px remove-file-icon"
                                style="display:flex;align-items: center;justify-content: center;"
                              >
                              <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3636 2.34047C13.715 2.34047 14 2.64876 14 3.02888C14 3.40919 13.715 3.71728 13.3636 3.71728H13.3548C13.2844 3.71728 13.2253 3.7776 13.2227 3.85558L12.7646 17.2377C12.731 18.2146 11.9762 19 11.0728 19H2.92723C2.02345 19 1.26904 18.2133 1.23544 17.2377L0.777349 3.85558C0.774686 3.77932 0.717158 3.71728 0.645248 3.71728H0.63637C0.28498 3.71728 0 3.40919 0 3.02888C0 2.64876 0.28498 2.34047 0.63637 2.34047H3.73886C3.80881 2.34047 3.88143 2.28035 3.90026 2.20909L4.10764 1.42347C4.32054 0.617499 5.07747 0 5.85253 0H8.14764C8.92269 0 9.67943 0.617352 9.89252 1.42347L10.0999 2.20909C10.1191 2.2817 10.1906 2.34047 10.2613 2.34047H13.3636ZM6.49084 6.19564V15.558C6.49084 15.8622 6.71864 16.1086 6.99989 16.1086C7.28113 16.1086 7.50894 15.8622 7.50894 15.558V6.19564C7.50894 5.89139 7.28113 5.64497 6.99989 5.64497C6.71864 5.64497 6.49084 5.8914 6.49084 6.19564ZM3.6909 6.21178L3.94552 15.5741C3.95387 15.8781 4.18824 16.1175 4.4693 16.1084C4.75037 16.0996 4.97162 15.8459 4.96326 15.5418L4.70864 6.17952C4.70047 5.87546 4.46592 5.63612 4.18486 5.64517C3.90378 5.654 3.68272 5.90774 3.6909 6.21178ZM9.29096 6.17951L9.03633 15.5418C9.02799 15.8459 9.24923 16.0996 9.53029 16.1084C9.81137 16.1174 10.0458 15.8781 10.0541 15.5741L10.3087 6.21176C10.3169 5.9077 10.0958 5.65396 9.81473 5.64516C9.53366 5.63613 9.29909 5.87546 9.29096 6.17951ZM5.31773 2.34047H8.68177C8.75385 2.34047 8.79523 2.28208 8.77623 2.21005L8.66845 1.80169C8.61163 1.58676 8.35417 1.37682 8.14731 1.37682H5.85219C5.64534 1.37682 5.38787 1.58695 5.33105 1.80169L5.22328 2.21005C5.2041 2.28285 5.24653 2.34047 5.31773 2.34047Z" fill="white"/>
</svg></i>
                </div>
                
                <div class="d-flex file-note-text mt-1" v-if="!pcrFileErr && !pcrFileUrl || !pcrFileUrl">
                <p class="mr-2" :class="pcrFileErr ? 'file-err-text' : ''" >
                <b v-if="!pcrFileErr && !pcrFileUrl ">Note: </b>
                  Uploaded image should be .png or .jpg and with max size 3MB
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="notes-section" style="padding-inline-start: 0">
          <span class="add-document-label" :class='{"remove-padding":pcr.pcr_notes && showPCRNoteLabel}' v-if="pcr.pcr_notes && !showPCRNoteLabel">Document Notes (Optional)</span>
          <b-form-textarea class="add-document-notes" v-model="pcr.pcr_notes" rows="5" placeholder="Document Notes (Optional)" maxlength="255"/>
        </div>
      </div>
    </div>

    <div v-if="form.document" class="action-btns">
      <button @click="onSubmit()" type="submit" :disabled="form.vaccine_pcr == 'covid_vaccine' && vaccine.vaccine_name && vaccine.vaccine_protocol && !isSubmitted &&
      vaccine.vaccine_taken_date && vaccine.vaccine_expire_date && vaccineFileUrl && !vaccineFileErr ? false : form.vaccine_pcr == 'covid_pcr' 
      && pcr.pcr_result && pcr.pcr_date && pcrFileUrl && !pcrFileErr && !isSubmitted ? false : true" 
      class="add-document-btn btn btn-primary" size="lg">{{ $t('common.add').toUpperCase() }} {{ $t('common.document').toUpperCase() }}<i v-if="isSubmitted" style="margin-inline-start:5px" class="bx bx-loader bx-spin font-size-16 align-middle rounded"></i></button>
    </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "AddDocument",
  data() {
    return {
      showVaccineNoteLabel:true,
      showPCRNoteLabel:true,
      form: {
        document: null,
        vaccine_pcr: null,
      },
      vaccine: {
        vaccine_protocol : null,
        vaccine_name: null,
        vaccine_number: null,
        vaccine_taken_date: null,
        vaccine_expire_date: null,
        vaccine_notes : '',
      },
      pcr: {
        pcr_result: null,
        pcr_date: null,
        pcr_notes: '',
      },
      protocolsOptions: [
        "EU Digital COVID Certificate",
        "NHS (Domestic/International)",
        "Smart Health Card (SHC)",
        "NYS Excelsior Pass & NYS Excelsior Pass Plus",
      ],
      pcrResultOptions: [
        {
          id: "positive",
          name: "Positive PCR",
        },
        {
          id: "negative",
          name: "Negative PCR",
        },
      ],
      vaccineFile : null,
      vaccineFileUrl : null,
      vaccineFileErr: false,
      isVaccineFileRemoved: false,
      pcrFile: null,
      pcrFileUrl: null,
      pcrFileErr: false,
      pcrFileImageChanged: null,
      isPcrFileRemoved: false,
      is_expired : false,
      isSubmitted: false,
      vaccineAndPrcSection : false,
      acceptNegativePcr : true,
    };
  },
  computed: {
    ...mapGetters("users", ["getDocuments", "getAcceptNegativePcr", "getLoading", "getModalState"]),
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("authfack", ["currentEntity"]),
  },
  methods: {
    ...mapActions("users", ["createDocument", "resetLoading", "onSelectDocument"]),
    disabledExpiredDate(date) {
      let takenDate = this.changeDateFormat(this.vaccine.vaccine_taken_date);
      return date < takenDate;
    },
    disableDateAfterCurrent(date) {
      return date > new Date();
    },
    changeDocumentType(type){
      this.vaccineAndPrcSection = false;
      this.form.vaccine_pcr = null;
      this.resetVaccineValues();
      this.resetPcrValues();
      if( type && type.id == "vaccine_document"){
        this.vaccineAndPrcSection = true;
        this.form.vaccine_pcr = 'covid_vaccine';
        if(!this.acceptNegativePcr){
          this.adjustDocumentTypeBottom();
        }
      }
    },
    pickImage() {
      document.getElementById("imagePicker").click();
    },
    onFileChange(e) {
      console.log('e',e);

      this.vaccineFileErr = false;
      this.pcrFileErr = false;
      this.vaccineFileUrl = null;
      this.isVaccineFileRemoved = true;
      this.vaccineFile = null;
      this.pcrFileUrl = null;
      this.isPcrFileRemoved = true;
      this.pcrFile = null;

      let file = e.target.files[0];
      if (!file || file.type.indexOf("image/") !== 0)
        return  
      
      const extensionType = file.type.split("/")[1];
      if(extensionType != 'png' && extensionType != 'jpeg'){
        if(this.form.vaccine_pcr == "covid_vaccine"){
          return this.vaccineFileErr = true;
        }else{
          return this.pcrFileErr = true;
        }
      }

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (evt) => {
        let newImg = new Image();
        newImg.onload = () => {
          if ( file.size > 3097152 ) {
            if(this.form.vaccine_pcr == "covid_vaccine"){
              return this.vaccineFileErr = true;
            }else{
              return this.pcrFileErr = true;
            }
          }
          let fileUrl = URL.createObjectURL(file);
          this.isVaccineFileRemoved = false;

          if(this.form.vaccine_pcr == "covid_vaccine"){
            this.vaccineFileUrl = fileUrl;
            this.isVaccineFileRemoved = false;
            this.vaccineFile = file;
          }else{
            this.pcrFileUrl = fileUrl;
            this.isPcrFileRemoved = false;
            this.pcrFile = file;

          }
        };
        newImg.src = evt.target.result;
      };
      reader.onerror = (evt) => {
        console.error(evt);
      };
    },
    removeImage() {
      this.vaccineFile = null;
      this.vaccineFileUrl = null;
      this.isVaccineFileRemoved = true;
      this.$refs.vaccineFileRef.value = [];
    },
    removePcrImage(){
      this.pcrFile = null;
      this.pcrFileUrl = null;
      this.isPcrFileRemoved = true;
      this.$refs.pcrFileRef.value = [];
    },
    changeVaccineOrPcr(){
      this.resetVaccineValues();
      this.resetPcrValues();
    },
    checkExpired() {
      if ( (this.form.vaccine_pcr == "covid_pcr" &&
          this.pcr.pcr_result.id == "positive") ||
        (this.form.vaccine_pcr == "covid_vaccine" &&
          this.vaccine.vaccine_expire_date < moment
              .utc(new Date())
              .tz(moment.tz.guess())
              .format("YYYY-MM-DD"))
      )
        this.is_expired = true;
      else this.is_expired = false;
    },
    resetVaccineValues(){
      this.vaccine.vaccine_protocol = null;
      this.vaccine.vaccine_name = null;
      this.vaccine.vaccine_number = null;
      this.vaccine.vaccine_taken_date = null;
      this.vaccine.vaccine_expire_date = null;
      this.vaccine.vaccine_notes = null;
      this.vaccineFile = null;
      this.vaccineFileUrl = null;
      this.vaccineFileErr = false;
    },
    resetPcrValues(){
      this.pcr.pcr_result = null;
      this.pcr.pcr_date = null;
      this.pcr.pcr_notes = null;
      this.pcrFile = null;
      this.pcrFileUrl = null;
      this.pcrFileErr = false;
    },
    changeVaccineDateTaken(){
      this.vaccine.vaccine_expire_date = null;
    },
    changeDateFormat(date){
      const [givenDateDay, givenDateMonth, givenDateYear] = date.toString().split("/");
      const newGivenDate = new Date(`${givenDateYear}-${givenDateMonth}-${givenDateDay}`);
      return newGivenDate;
    },
    adjustDocumentTypeBottom(){
      setTimeout(()=>{
        let adjustDocumentTypeBottom = document.querySelector('div#addDocumentModal div#addDocumentModal___BV_modal_content_ div#addDocumentModal___BV_modal_body_ .vaccine-and-pcr-details .document-type');
        adjustDocumentTypeBottom.classList.remove('select-type');
        adjustDocumentTypeBottom.classList.add('mb-14');
      },110);
    },
    onSubmit() {
      // e.preventDefault();
      const {
        form,
        vaccine,
        pcr,
        currentEntity,
        getModalInfo,
        createDocument,
      } = this;
      const { document, vaccine_pcr } = form;
      const {
        vaccine_name,
        vaccine_number,
        vaccine_taken_date,
        vaccine_expire_date,
        vaccine_protocol,
        vaccine_notes,
      } = vaccine;
      const { pcr_result, pcr_date, pcr_notes } = pcr;
      const {first_name,last_name,id} = getModalInfo;
      //   validation
      this.isSubmitted = true;
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //   return;
      // } else {
        const vaccineData = {
          protocol: vaccine_protocol,
          fileAttach : this.vaccineFile,
          certificateModel: {
            extraData: {},
            dateOfBirth: "",
            kid: "",
            person: {
              familyName: last_name,
              givenName: first_name,
              standardisedFamilyName: last_name,
              standardisedGivenName: first_name,
            },
            signature: "",
            vaccinations: [
              {
                certificateIdentifier: "",
                certificateIssuer: "",
                countryOfVaccination: "",
                dateOfVaccination: moment(vaccine_taken_date, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm:ss"),
                disease: "COVID-19",
                doseNumber: "",
                manufacturer: "",
                medicinalProduct: "",
                totalSeriesOfDoses: "",
                batchNumber:vaccine_number,
                vaccine: vaccine_name,
              },
            ],
          },
          generalVerificationResult: "",
          greenCertificatData: {
            expirationTime: moment(vaccine_expire_date, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm:ss"),
            issuedAt: "",
            issuingCountry: "",
          },
          type: "",
          notes : vaccine_notes,
        };
        const pcrData = {
          fileAttach : this.pcrFile,
          certificateModel: {
            dateOfBirth: "",
            kid: "",
            person: {
              familyName: last_name,
              givenName: first_name,
              standardisedFamilyName: last_name,
              standardisedGivenName:first_name,
            },
            signature: "",
            tests: [
              {
                disease: "",
                typeOfTest: "",
                testName: "",
                testNameAndManufacturer: null,
                dateTimeOfCollection: "",
                dateTimeOfTestResult: moment(pcr_date, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm:ss"),
                testResult: (pcr_result && pcr_result.id =="positive")?"Detected":"Not detected",
                testResultCode:(pcr_result && pcr_result.id =="positive")?"260373001":"260415000",
                testingCentre: "",
                countryOfVaccination: "",
                certificateIssuer: "",
                certificateIdentifier: "",
                countryCode: "",
              },
            ],
          },
          generalVerificationResult: "",
          greenCertificatData: {
            expirationTime: "",
            issuedAt: "",
            issuingCountry: "",
          },
          type: "INTERNATIONAL",
          notes : pcr_notes,
        };

        // const data = {
        //   entity_id: currentEntity.id,
        //   user_id: id,
        //   document: document && document.id,
        //   expiry_date: moment(vaccine_expire_date, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm:ss"),
        //   start_date : vaccine_pcr == "covid_vaccine" ? null : pcr_date,
        //   type: vaccine_pcr,
        //   notes : vaccine_pcr == "covid_vaccine" ? vaccine_notes : pcr_notes,
        //   metadata: vaccine_pcr == "covid_vaccine" ? vaccineData : pcrData,
        // };
        let formData = new FormData();
        formData.append("entity_id", currentEntity.id);
        formData.append("user_id", id);
        formData.append("document", document ? document.id : '');
        formData.append("expiry_date", vaccine_expire_date ? moment(vaccine_expire_date, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm:ss") : '');
        formData.append("start_date", vaccine_pcr == "covid_vaccine" ? '' :  moment(pcr_date, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm:ss"));
        formData.append("type", vaccine_pcr);
        formData.append("notes", vaccine_pcr == "covid_vaccine" ? vaccine_notes : pcr_notes);
        formData.append("metadata[fileAttach]", vaccine_pcr == "covid_vaccine" ? this.vaccineFile : this.pcrFile);
        formData.append("metadata[protocol]", vaccine_protocol);
        formData.append("metadata[certificateModel][extraData]", {});
        formData.append("metadata[certificateModel][dateOfBirth]", '');
        formData.append("metadata[certificateModel][kid]", '');
        formData.append("metadata[certificateModel][person][familyName]", last_name);
        formData.append("metadata[certificateModel][person][givenName]", first_name);
        formData.append("metadata[certificateModel][person][standardisedFamilyName]", last_name);
        formData.append("metadata[certificateModel][person][standardisedGivenName]", first_name);
        formData.append("metadata[certificateModel][signature]", '');
        formData.append("metadata[generalVerificationResult]", '');
        formData.append("metadata[greenCertificatData][expirationTime]", vaccine_expire_date ? moment(vaccine_expire_date, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm:ss") : "" );
        formData.append("metadata[greenCertificatData][issuedAt]", '');
        formData.append("metadata[notes]", vaccine_pcr == "covid_vaccine" ? vaccine_notes : pcr_notes,);
        formData.append("metadata[type]", vaccine_pcr == "covid_pcr" ? 'INTERNATIONAL' : '');

        if (vaccine_pcr == "covid_vaccine") {
          for (let i = 0; i < vaccineData.certificateModel.vaccinations.length; i++) {
            for (let key of Object.keys(vaccineData.certificateModel.vaccinations[i])) {
              formData.append(`metadata[certificateModel][vaccinations][${i}][${key}]`, vaccineData.certificateModel.vaccinations[i][key]);
            }
          }
        } else if (vaccine_pcr == "covid_pcr") {
          for (let i = 0; i < pcrData.certificateModel.tests.length; i++) {
            for (let key of Object.keys(pcrData.certificateModel.tests[i])) {
              formData.append(`metadata[certificateModel][tests][${i}][${key}]`, pcrData.certificateModel.tests[i][key]);
            }
          }
        }
        createDocument(formData).then(()=> this.$emit('changeUserStatusOrDeleted', this.getModalInfo.id));
      // }
    },
  },
  created(){
    if(!this.getAcceptNegativePcr){
      this.acceptNegativePcr = false;
      this.form.vaccine_pcr = 'covid_vaccine';
    }
  },
  watch:{
    // 'form.document'(value){
    //   value && this.onSelectDocument(true);
    // },
    'vaccine.vaccine_notes'(){
      let textArea = document.querySelector('.add-document-notes');
      this.showVaccineNoteLabel = textArea?.scrollHeight > textArea?.clientHeight + 3
    },
    'pcr.pcr_notes'(){
      let textArea = document.querySelector('.add-document-notes');
      this.showPCRNoteLabel = textArea?.scrollHeight > textArea?.clientHeight + 3
    },
    getModalState(modalState) {
      modalState && this.$bvModal.hide("addDocumentModal");
    },
  },
  beforeMount() {
    this.resetLoading();
  },
};
</script>

<style lang="scss">
  div#addDocumentModal {
    div#addDocumentModal___BV_modal_content_ {
      width: 491px;
      background: #FFFFFF;
      box-shadow: 0px 1px 40px 3px rgb(0 0 0 / 5%);
      border-radius: 26px !important;
      div#addDocumentModal___BV_modal_body_{
        padding:0px!important;

        .modal-title-head{
            .title-head {
              
               
              font-weight: 700;
              font-size: 17px;
              line-height: 20px;
              margin:33px auto 31px auto;
              color: #000000;
              margin-inline-end: 141px;
              p{
                
                 
                font-weight: 700;
                font-size: 17px;
                line-height: 20px;
              }
            }
        }

        .closeAddDocumentModal{
          margin-top: 33px;
          margin-inline-end: 33px;
          cursor: pointer;  
        }

        .vaccine-and-pcr-details{
          padding-inline-end: 38px;
          padding-inline-start: 38px;

          .select-type {
            margin-bottom: 47px;
          }

          .vaccine-radio{
            margin-inline-start: 12px;
          }

          .pcr-radio{
            margin-inline-start: 17px;
          }

          .custom-radio {
            margin-bottom: 31px;
            label.custom-control-label {
              position: relative;
              padding-inline-start:20px;
              
               
              font-weight: 400;
              font-size: 16px;
              line-height: 17px;
              /* identical to box height, or 106% */
              letter-spacing: 0.25px;
              /* #606060 */
              color: rgba(96, 96, 96, 0.87);
              opacity: 0.8;
              padding-top: 3px;
            }
            .custom-control-input:checked ~ .custom-control-label{
              
               
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;
              /* identical to box height, or 106% */
              letter-spacing: 0.25px;
              /* Main Button */
              color: #103F5E;
              opacity: 0.8;
            }
            .custom-control-input:checked ~ .custom-control-label::before {
              color: #fff;
              width: 20px;
              height: 20px;
              border-color: #000000!important;
              background: #000000!important;
              opacity: 0.3;
            }
            .custom-control-input ~ .custom-control-label::before {
              color: #fff;
              width: 20px;
              height: 20px;
              border-color: #000000!important;
              background: #000000!important;
              opacity: 0.3;
            }
            .custom-control-input:checked ~ .custom-control-label::after {
              background-image: none;
              background: #103F5E!important;
              width: 12px;
              height: 12px;
              border-radius: 50%;
              position: absolute;
              top: 6px;
              inset-inline-start: -20px;
            }
            .custom-control-input:checked ~ .custom-control-label::before {
              color: #fff;
              width: 20px;
              height: 20px;
              border-color: #000000!important;
              background: #000000!important;
              opacity: 0.3;
            }

          }
        }
        .documents {
          width: 415px !important;
          margin: 0px auto 32px auto;
          label {
            margin-top: 0px;
            margin-inline-end: auto;
            margin-bottom: 30px;
            margin-inline-start: 10px;
             
             
            font-weight: 700;
            font-size: 16px;
            line-height: 19px;

            color: #939393;
          }
          .multiselect__tags {
            height: 55px !important;
            background: #f2f2f2 !important;
            border-radius: 4px !important;
            border: none !important;
            span.multiselect__placeholder {
              background: transparent !important;
              margin-top: 10px !important;
              font-weight: 700 !important;
              font-size: 16px !important;
              line-height: 17px;
              margin-inline-start: 10px;
              letter-spacing: 0.25px;

              color: #787878 !important;

              opacity: 0.8;
            }

            .multiselect__input {
              background: transparent !important;
            }
          }
        }
        .document-details {
          margin: 0px auto 35px auto;
           
           
          font-weight: 400;
          font-size: 16px;
          line-height: 20px;
          width: 248px;

          letter-spacing: 0.25px;

          color: #666666;
        }
        .vaccine-pcrradio {
          width: 225px;
          margin-inline-start: 54px;
          margin-bottom: 35px;
          label.custom-control-label {
            padding-inline-start: 20px;
          }
          .pcr-radio.custom-control.custom-radio {
            margin-inline-start: 56px;
          }
        } 
        .vaccine-inputs-wrapper {
          width: 415px;
          margin: auto;
          input#name {
            height: 55px;
             
             
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;

            position: relative;
            letter-spacing: 0.25px;

            color: rgba(0, 0, 0, 0.87);

            opacity: 0.8;
            transition: 0.6s;
            background: #f2f2f2;
            border-radius: 4px;
            border: none;
          }
          input#name::placeholder {
             
             
            font-weight: 400;
            font-size: 16px;
            line-height: 17px;
            // padding-inline-start: 15px;
            // padding-top: 15px;
            letter-spacing: 0.25px;

            color: rgba(96, 96, 96, 0.87);

            opacity: 0.8;
          }
          input#name:focus::placeholder {
            top: 4px !important;
             
             
            font-weight: 700 !important;
            font-size: 12px !important;
            line-height: 17px !important;
            position: absolute !important;
            letter-spacing: 0.25px !important;

            color: #103f5e !important;

            opacity: 0.8;
          }
          input#number {
            height: 55px;
            background: #f2f2f2;
            border-radius: 4px;
             
             
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            position: relative;

            letter-spacing: 0.25px;

            color: rgba(0, 0, 0, 0.87);

            opacity: 0.8;
            border: none;
          }
          input#number::placeholder {
             
             
            font-weight: 400;
            font-size: 16px;
            line-height: 17px;
            position: absolute;
            cursor: text;
            top: 15px;
            transition: transform 0.3s ease;

            letter-spacing: 0.25px;

            color: rgba(96, 96, 96, 0.87);

            opacity: 0.8;
          }
          input#number:focus::placeholder {
            top: 4px !important;
             
             
            font-weight: 700 !important;
            font-size: 12px !important;
            line-height: 17px !important;

            letter-spacing: 0.25px !important;

            color: #103f5e !important;

            opacity: 0.8;
          }
          input.mx-input {
            height: 55px !important;
            background: #f2f2f2 !important;
            border-radius: 4px;
            border: none !important;
            padding-inline-start: 20px !important;
            padding-bottom: 5px !important;
            
             
            font-weight: 700 !important;
            font-size: 16px !important;
            line-height: 17px !important;
            letter-spacing: 0.25px;
            color: rgba(0, 0, 0, 0.87) !important;
            opacity: 0.8;
          }
          div#date {
            width: 200px !important;
            margin-inline-end: 15px;
             
             
            font-weight: 700 !important;
            font-size: 16px !important;
            line-height: 17px !important;
            /* identical to box height, or 106% */

            letter-spacing: 0.25px;

            color: rgba(0, 0, 0, 0.87);

            opacity: 0.8;
            ::placeholder {
               
               
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;

              letter-spacing: 0.25px;

              color: #787878;
            }
            //focus
          }
          div#expire_date {
            width: 200px !important;
             
             
            font-weight: 700 !important;
            font-size: 16px !important;
            line-height: 17px !important;
            /* identical to box height, or 106% */

            letter-spacing: 0.25px;

            color: rgba(0, 0, 0, 0.87);

            opacity: 0.8;
            ::placeholder {
               
               
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;

              letter-spacing: 0.25px;

              color: #787878;
            }
          }

          .protocols-multiselect {
            margin-bottom: 15px;
          }
        }

        .mb-14{
          margin-bottom: 14px !important;
          width: 416px;
        }

        .multiselect__tags {
            height: 55px !important;
            background: #f2f2f2 !important;
            border-radius: 4px !important;
            border: none !important;
            span.multiselect__placeholder {
              background: transparent !important;
              margin-top: 10px !important;
              font-weight: 700 !important;
              font-size: 16px !important;
              line-height: 17px;
              margin-inline-start: 10px;
              letter-spacing: 0.25px;
              color: #787878 !important;
              opacity: 0.8;
            }
            span.multiselect__single {
              background: transparent !important;
              /* height: 48px; */
              /* width: 300px; */
               
               
              font-weight: 700 !important;
              font-size: 16px !important;
              line-height: 17px !important;
              letter-spacing: 0.25px !important;
              color: rgba(0, 0, 0, 0.87) !important;
              opacity: 0.8;
              margin-top: 20px !important;
              margin-inline-start: 8px !important;
            }
            .multiselect__input {
              background: transparent !important;
            }
          }

        .pcr-inputs-wrapperr {
          input.mx-input {
            height: 55px !important;
            background: #f2f2f2 !important;
            border-radius: 4px;
            border: none !important;
            padding-inline-start: 20px !important;
            padding-bottom: 5px !important;
            
             
            font-weight: 700 !important;
            font-size: 16px !important;
            line-height: 17px !important;
            letter-spacing: 0.25px;
            color: rgba(0, 0, 0, 0.87) !important;
            opacity: 0.8;
          }
          input.mx-input::placeholder {
             
             
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            letter-spacing: 0.25px;
            // margin-inline-start: 20px;
            // padding-inline-start: 10px;
            color: #787878;
          }
          i.mx-icon-calendar {
            margin-inline-end: 10px;
          }
        }

        .remove-file-icon{
          position:absolute;
          z-index: 5;
          width:51px;
          height:39px; 
          border-radius: 5px;
          bottom:6px;
          inset-inline-start:143px;
          opacity:0;
          color:#ffffff      
        }
        .remove-file-icon:hover{
          background-color: #666666;
          opacity: 0.8 !important;
          display: block;
          cursor: pointer;
        }

        .remove-btn {
          position: relative;
          bottom: 40px;
          inset-inline-start: 20%;
          width: 68px;
          height: 25px;
          border: none;
          color: #fff;
           
           
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          color: #ffffff;
          border-radius: 16px;
          background: #f46a6a;
        }

        .file-validation{
          border: red solid 1px;
        }


        .paperclip-icon{
          position:relative;
          margin-inline-end:16px;
        }

        .file-note-text{
           
          font-size:14px;
          line-height:22.5px ;
          letter-spacing:0.25px;
          color:#939393;
          font-weight: 400;
          max-width:200px;
          padding-inline-start:15px;
          padding-inline-end:15px;
          b{
            font-weight:700;
          }
        }
        .file-err-text{
          font-size:14px;
          line-height:22.5px ;
          letter-spacing:0.25px;
          font-weight:600;
          color:#F46A6A;
          // max-width:0px;
          padding-inline-start:0px;
          padding-inline-end:0px;
        }
        .pcr-datepicker{
          width:200px !important;
        }

        .file-label-img-selected{
          color:#3D637C !important;
        }

        .file-label {
          color: #787878;
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          min-width: 150px;
          margin-inline-start: 14px;
          margin-bottom: 15px;
        }

        .file-label:lang(ar){
          line-height: 21px;
        }

        .upload-btn {
          background-color: #f2f2f2;
          color: #000000;
          width: 200px;
          height: 55px;
          border-radius: 4px;
          border: 0;
        }

        .img-bg {
          position:absolute;
          z-index: 4;
          width:50.5px;
          height:38.4px; 
          border-radius: 5px !important;
          bottom:7px;
          inset-inline-start:143px;
          border:0px
        }

        textarea::placeholder {
          
           
          font-weight: 400;
          font-size: 16px;
          line-height: 17px;
          margin-top: 46px;
          letter-spacing: 0.25px;
          letter-spacing: 0.25px;
          color: rgba(96, 96, 96, 0.87);

          opacity: 0.8;
        }

        textarea {
          width : 415px;
          height : 100px;
          border: none;
          margin: 0px auto 14px auto;
          margin-bottom: 9px;
          resize: none;
           
           
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          letter-spacing: 0.25px;
          color: rgba(0, 0, 0, 0.87)!important;
          opacity: 0.8; 
          background: #F2F2F2;
          border-radius: 4px;
          padding-inline-start: 20px !important;
          padding-top: 26px !important;
        }

        .action-btns{
          .add-document-btn {
            width: 415px;
            margin-top: 28px;
            margin-bottom: 38px;
            border-radius: 22px;
            background-color: #103f5e;
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            color: #ffffff;
            height: 44px;
          }
          .add-document-btn:disabled {
            cursor: not-allowed;
            opacity: 0.4;
          }
        }
        .add-document-label ,.add-document-date-label{
          position: absolute;
          margin-inline-start: 20px;
          margin-top: 9px;
          z-index: 2;
          color: #103f5e;
          font-size: 12px;
          opacity: 0.8;
           
          font-weight: 700;
           
          line-height: 17px;
          letter-spacing: 0.25px;
          opacity:0.8;
        }
        .add-document-date-label{
          margin-top: 5px;
        }
        .add-document-notes{
          
          font-size: 16px;
          font-weight: 700;
          line-height: 17px;
          letter-spacing: 0.25px;
          opacity: 0.8;
        }
        .remove-padding{
          padding-top:12px !important;
        }
      }
    }
  }
</style>